import { render, staticRenderFns } from "./BRELAG_Status.vue?vue&type=template&id=66038bd8&"
import script from "./BRELAG_Status.vue?vue&type=script&lang=js&"
export * from "./BRELAG_Status.vue?vue&type=script&lang=js&"
import style0 from "./BRELAG_Status.vue?vue&type=style&index=0&id=66038bd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports